import React, { useContext } from "react";
import FloatCard from "../components/ui/FloatCard";
import { theme } from "../theme";
import Method from "../components/Method";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import Trajectory from "../components/Trajectory";
import Forecast from "../components/Forecast";
import Concerns from "../components/Concerns";
import { General } from "../tools/styles"
import Generic from "../components/Generic";
import calcForecast from "../tools/calcForecast";
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import calcComplete from "../tools/calcComplete";
import calcCurrentConcern from "../tools/calcCurrentConcern";
import calcFutureConcern from "../tools/calcFutureConcern";
import BackToDash from "../components/BackToDash";

const Vertical = () => {

  let {vertical, setVertical} = useContext(WatchContext);

  const handleChange = ({ target }) => {
    
    let data = handleInputChange(vertical, target)
    let slrForecast = parseFloat(data.slrRate * data.forecastYears)

    data.slrLow = (parseFloat(
      data?.criteriaLow) + slrForecast
    ).toFixed(2);
  
    data.slrHigh = (parseFloat(data?.criteriaHigh) + slrForecast
    ).toFixed(2);

    data.currentConcern = calcCurrentConcern(data)
    data.forecastLow = calcForecast(data, data.trajectLow)
    data.forecastHigh = calcForecast(data, data.trajectHigh)
    data.futureConcern = calcFutureConcern(data)
    data.complete = calcComplete(data);    

    setVertical(data);
  };  

  let topicItem = vertical.metrics?.filter(
    (item) => item.metric === vertical.metric
  )[0] ?? { methods: [] };
  let methods = topicItem.methods.map((item) => item.method) ?? [];

  // console.log('vertical test', vertical)

  return (
    <General.Background backgroundColor={`${theme.colors.pdeGreen + 40}`}>
      <General.Heading color={theme.colors.pdeGreen}>
        Vertical Position
      </General.Heading>
      <BackToDash/>      
      <Generic
     text={vertical.metric}
     title='Metric'
     />
      <Method
        currentValue={vertical.method}
        methodArray={methods}
        handleChange={handleChange}
      />
      <Current
        currentValue={vertical.currentValue}
        valDesc='Negative values represent a loss (erosion, subsidence) of elevation.'
        units={vertical.units}
        unitDesc='Relative to a vertical datum.'
        just={vertical.currentJust}
        handleChange={handleChange}
      />
      <Criteria
        low={vertical.criteriaLow}
        high={vertical.criteriaHigh}
        units={vertical.units}
        type={vertical.criteriaType}
        just={vertical.criteriaJust}
        handleChange={handleChange}
      />
      <Trajectory
        low={vertical.trajectLow}
        high={vertical.trajectHigh}
        units={vertical.units}
        just={vertical.trajectJust}
        handleChange={handleChange}
      />

      <Forecast
        years={vertical.forecastYears}
        just={vertical.forecastJust}
        units={vertical.units}
        forecastLow={vertical.forecastLow}
        forecastHigh={vertical.forecastHigh}
        handleChange={handleChange}
      />
      <General.BlockContainer>
        <General.Block>
          <FloatCard width="300px">
            <General.InputCont>
              <span>Sea Level Rise Rate</span>
              <General.Input
                type="number"
                name="slrRate"
                value={vertical.slrRate}
                onChange={handleChange}
                placeholder="Enter a number"
              />
            </General.InputCont>
            <General.InputCont>
              <span>Sea Level Rise Rate Units: {vertical.units}</span>
            </General.InputCont>
            <General.InputCont>
          <span>New criteria range relative to sea level rise</span>
        </General.InputCont>
            <General.InputCont>
              <span>
                From: {vertical.slrLow} {vertical.slrUnits}
              </span>
            </General.InputCont>
            <General.InputCont>
              <span>
                To: {vertical.slrHigh} {vertical.slrUnits}
              </span>
            </General.InputCont>
          </FloatCard>
        </General.Block>
        <General.Block color={theme.colors.grey4}>
          <div>
          <h2>Sea Level Rise</h2>
          <General.LimitText width="250px"><a href='https://tidesandcurrents.noaa.gov/sltrends/' target='_blank' rel='noreferrer'>Get SLR data</a></General.LimitText>
          </div>
        </General.Block>
      </General.BlockContainer>
      <Concerns
        currentConcern={vertical.currentConcern}
        futureConcern={vertical.futureConcern}
        metric={vertical.metric}
      />
      <BackToDash/>
    </General.Background>
  );
};

export default Vertical;
